import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLandmarkFlag } from '@fortawesome/pro-duotone-svg-icons';
import BreadCrumbs from './BreadCrumbs';
import FeatureNav from './FeatureNav';
import FooterSection from './FooterSection';
import HeaderComponent from './HeaderComponent';
import PropertyValues from "../assets/images/property_values.svg";
import StateRevEx from "../assets/images/state_rvex.svg";
import '../assets/styles/main.css';

const StateOfUtah = () => {
  return (
    <div className="state-of-utah" id="state-of-utah">
      <HeaderComponent/>
      <FeatureNav />
      <BreadCrumbs/>
      <section className="mt-20">
        <div className="text-center mb-4">
          <h1 className="display-5 fw-bold mb-3">State of Utah</h1>
        </div>

        <div
          className="jumbotron border text-light rounded my-4 mx-4 pt-3 pb-0 border shadow px-0"
          style={{ backgroundColor: "var(--tu-teal)"}}
        >
        <div className="col-12 py-2 rounded" style={{ paddingLeft: "15px"}}>
          <h3 className="text-light">
            <FontAwesomeIcon icon={faLandmarkFlag} className="me-2" />
            State of Utah
          </h3>
          <p className="lead">Use these tools for statewide analysis</p>
        </div>

        <div className="col-12 bg-light">
          <div className="row justify-content-center px-3">

            {/* Property Values Card */}
            <article className="col-auto py-3">
              <a
                className="card mb-4 box-shadow h-100"
                target="_blank" 
                rel="noopener noreferrer"
                href="https://old.transparent.utah.gov/property.php"
                title="Property Values"
              >
                <div
                  className="card-header text-center text-white"
                  style={{ backgroundColor: "var(--tu-teal)"}}
                >
                  Property Values
                </div>
                <img
                  className="card-img-top"
                  alt="Property Values Thumbnail"
                  src={PropertyValues}
                  data-holder-rendered="true"
                />
                <div className="card-body py-0">
                  <p className="card-text text-center">
                    Examine property assessments across the state
                  </p>
                </div>
              </a>
            </article>

            {/* State Revenues & Expenditures Card */}
            <article className="col-auto py-3">
              <a
                className="card mb-4 box-shadow h-100"
                target="_blank" 
                rel="noopener noreferrer"
                href="https://old.transparent.utah.gov/state_rvex.php"
                title="State Revenue & Expenditure"
              >
                <div
                  className="card-header text-center text-white px-0"
                  style={{ backgroundColor: "var(--tu-teal)"}}
                >
                  State Revenues & Expenditures{" "}
                  <span className="badge bg-info ms-1">New</span>
                </div>
                <img
                  className="card-img-top"
                  alt="State Revenues & Expenditures Thumbnail"
                  src={StateRevEx}
                  data-holder-rendered="true"
                />
                    <div className="card-body py-0">
                    <p className="card-text text-center">
                        Take a 20-year deep dive into the Revenues and Expenditures
                        for which the state is financially accountable.
                    </p>
                    </div>
                </a>
            </article>
            </div>
            </div>
        </div>
      </section>
      <FooterSection />
    </div>
  );
};

export default StateOfUtah;
